module.exports = __webpack_public_path__ + "static/media/NarroginObserver-devicecomp-min@2x.0ab5b7bf.webp";